import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../../dropdown'
import config from '../../../../config'

import { AuthCompromis } from './AuthCompromis'
import { AuthDretsImatge } from './AuthDretsImatge'
import { AuthGDPR } from '../common/AuthGDPR'
import { AuthSortides } from './AuthSortides'
import { AuthMedica } from './AuthMedica'
import { AuthRecursosDigitalsMenors14, AuthRecursosDigitalsMenors18, AuthRecursosDigitalsMajors18 } from './AuthRecursosDigitals'
import { AuthPortatils } from './AuthPortatils'
import { AuthResponsable } from '../common/AuthResponsable'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authDretsImatge , setAuthDretsImatge ] = useState("1");

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authSortides, setAuthSortides ] = useState();
  const [authMedica, setAuthMedica] = useState("0");
  const [authReligio, setAuthReligio ] = useState(props.dadesEstudis.authReligio ||"0");
  const [authPortatils, setAuthPortatils ] = useState("0");
  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authRecursosDigitals, setAuthRecursosDigitals] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  /* ESO i BATX de continuïtat (alumnat que continua, no nou) només han de signar la declaració responsable */
  const esFaseContinuitat = (props.dadesEstudis.cicle === "ESO" || props.dadesEstudis.cicle === "BATX") && !props.dadesEstudis.nouAlumne

  const authPortatilsCriteria = props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE")

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,

    /* DADES AUTORITZACIONS */
    "authCompromis": authCompromis,
    "authGDPR": authGDPR,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authMedica": authMedica,
    "authResponsable": authResponsable,
    "authPortatils": authPortatils,
    "authRecursosDigitals": authRecursosDigitals, // especific
    "authReligio": authReligio,
  }

      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }


  const validaAuthDretsImatge = () => {
    //només obligatori pels menors de 14
    //if(props.dadesPersonals.edat >= 14 ) return null
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }

  const validaAuthReligio= () => {
    return authReligio === "0" ? "Heu d'indicar una opció" : null
  }

  const validaAuthMobils = () => {
    return authRecursosDigitals === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPortatils = () => {
    return authPortatils === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable= () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthRecursosDigitals= () => {
    return authRecursosDigitals === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthMedica = () => {
    return authMedica === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthSortides = () => {
    return authSortides?.length ? null : "Aquest.camp és obligatori. Heu de triar una de les dues opcions"
  }

 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangePortatils = (t) => {

      setAuthPortatils(t === "0" ? "1" : "0")

      handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      //setAuthSortides(t === "0" ? "1" : "0")
      setAuthSortides(t)

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeRecursosDigitals = (t) => {

      setAuthRecursosDigitals(t === "0" ? "1" : "0")

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeReligio = (t) => {

    if(props.dadesEstudis.authReligio) return true;

    // valor de t: "1" o "2"
     setAuthReligio(t)

     handleDadesAutoritzacions(false)
 }

 // Drets d'imatge: assignació directa de l'estat (a l'original no notifica handleDadesAutoritzacions en canviar)
 const handleChangeDretsImatge = (t) => {
      setAuthDretsImatge(t)
 }




/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  /* ESO i BATX de continuitat només authResponsable */
if( !esFaseContinuitat )
{

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  error.authDretsImatge = validaAuthDretsImatge();
  handleErrors('authDretsImatge', error)

  if(authPortatilsCriteria)
  {
    error.authPortatils = validaAuthPortatils();
    handleErrors('authPortatils',error)
  }

  error.authMedica = validaAuthMedica();
  handleErrors('authMedica',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)


 if(props.dadesPersonals.edat < 18 ){
  error.authSortides= validaAuthSortides();
  handleErrors('authSortides',error)
  }

  error.authRecursosDigitals = validaAuthRecursosDigitals();
  handleErrors('authRecursosDigitals',error)

}

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  setErrors(error)

  let noError = true;
  //DEVELOP
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error,noError);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades i autoritzacions
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

{ /* ESO de continuitat només authResponsable */ }
{ !esFaseContinuitat && (<>

                                <AuthCompromis auth={authCompromis} handleChange={handleChangeCompromis} error={errors.authCompromis} enguany={props.enguany} anyVinent={props.anyVinent} />

<br/>
<br/>

                                <AuthDretsImatge auth={authDretsImatge} handleChange={handleChangeDretsImatge} error={errors.authDretsImatge} enguany={props.enguany} anyVinent={props.anyVinent} />

                                <br/>

                                <AuthGDPR auth={authGDPR} handleChange={handleChangeGDPR} error={errors.authGDPR} />

                                <br/>

                                { props.dadesPersonals.edat < 18 && (
                                  <AuthSortides auth={authSortides} handleChange={handleChangeSortides} error={errors.authSortides} />
                                )}

                                <br/>

                                <AuthMedica auth={authMedica} handleChange={handleChangeMedica} error={errors.authMedica} />

                                <br/>

                                { props.dadesPersonals.edat < 14 ? (
                                  <AuthRecursosDigitalsMenors14 auth={authRecursosDigitals} handleChange={handleChangeRecursosDigitals} error={errors.authRecursosDigitals} />
                                ) : (
                                  props.dadesPersonals.edat < 18 ? (
                                    <AuthRecursosDigitalsMenors18 auth={authRecursosDigitals} handleChange={handleChangeRecursosDigitals} error={errors.authRecursosDigitals} />
                                  ) : (
                                    <AuthRecursosDigitalsMajors18 auth={authRecursosDigitals} handleChange={handleChangeRecursosDigitals} error={errors.authRecursosDigitals} />
                                  )
                                )}

                                <br />

                                { authPortatilsCriteria && (<>
                                <AuthPortatils auth={authPortatils} handleChange={handleChangePortatils} error={errors.authPortatils} />

                                  <br/>
                                  </>)}

</>)}

                                <AuthResponsable auth={authResponsable} handleChange={handleChangeResponsable} error={errors.authResponsable}
                                  titol="Declaració responsable de veracitat de les dades aportades i acceptació"
                                  textAddicional="Que aquestes autoritzacions tindran vigència durant l'escolarització de l'alumne/a al centre." />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
